export const WarningIcon = () => {
  return (
    <svg
      data-testid="warning-icon"
      width="2.25rem"
      height="2.25rem"
      viewBox="0 0 24 22"
      xmlns="http://www.w3.org/2000/svg"
      fontSize="21px"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 21.5L12 0.772705L24 21.5H0ZM20.2145 19.3181L12 5.12539L3.78541 19.3181H20.2145ZM13.0909 16.0454H10.9091V18.2272H13.0909V16.0454ZM10.9091 9.49999H13.0909V13.8636H10.9091V9.49999Z"
        fill="#5A5A5A"
      ></path>
    </svg>
  );
};
